import React, { useEffect, useState } from 'react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 14,
    minutes: 46,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-end justify-center gap-3 sm:gap-4" data-id="element-503">
      <TimeUnit value={formatNumber(timeLeft.hours)} label="Horas" data-id="element-504" />
      <span className="text-2xl sm:text-3xl font-light text-white/30 pb-7 sm:pb-8" data-id="element-505">
        :
      </span>
      <TimeUnit value={formatNumber(timeLeft.minutes)} label="Min" data-id="element-506" />
      <span className="text-2xl sm:text-3xl font-light text-white/30 pb-7 sm:pb-8" data-id="element-507">
        :
      </span>
      <TimeUnit value={formatNumber(timeLeft.seconds)} label="Seg" data-id="element-508" />
    </div>;
}
function TimeUnit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-509">
      <div className="bg-white/10 border border-white/15 backdrop-blur-sm text-white w-16 h-16 sm:w-20 sm:h-20 rounded-2xl flex items-center justify-center text-3xl sm:text-4xl font-display font-bold mb-2" data-id="element-510">
        {value}
      </div>
      <span className="text-[10px] sm:text-xs font-semibold text-white/60 uppercase tracking-[0.15em]" data-id="element-511">
        {label}
      </span>
    </div>;
}